<template>
  <el-dialog
    title="监测规则"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose"
  >
    <div>
      <div class="box-table">
          <table>
        <tbody>
          <tr>
            <th class="th title-th"><strong>一级指标</strong></th>
            <th class="title-th" colspan="2"><strong>二级指标</strong></th>
            <th class="title-th"><strong>评分细则</strong></th>
          </tr>
          <tr>
            <th class="th" rowspan="3">单项否决</th>
            <th class="th" colspan="2">站点可用性</th>
            <th>
              连续监测一周，每天间隔性访问20次以上，超过（含）15秒网站仍打不开的次数累计占比超过（含）5%，即单项否决。
            </th>
          </tr>
          <tr>
            <th class="th" colspan="2">首页不更新</th>
            <th>
              <div class="txt-box">1.监测两周，首页无信息更新的，即单项否决（无发布时间视为不更新）。</div>
              <div class="txt-box">2.如首页仅为网站栏目导航入口，所有二级页面无信息更新的，即单项否决（无发布时间视为不更新）。</div>
            </th>
          </tr>
          <tr>
            <th class="th"  colspan="2">栏目不更新</th>
            <th>
             <div class="txt-box"> 1.检测时间点前2周内的动态、要闻类栏目，以及检测时间点前6个月内的通知公告、政策文件类一级栏目，累计超过（含）5个未更新。</div>
             <div class="txt-box">2.应更新但长期未更新的其他类栏目数量超过（含）10个。</div>
             <div class="txt-box">3.空白栏目数量超过（含）5个。</div> 
             <div class="txt-box">4. 上述情况出现任意一种，即单项否决。</div>
            </th>
          </tr>
          <tr>
            <th class="th" rowspan="5">综合扣分项（100分）</th>
            <th colspan="2" class="th">链接可用性</th>
            <th>
              <div class="txt-box">1.首页上的链接（包括图片、附件、外部链接等）打不开或错误的，每发现一处，扣0.2分，如首页仅为网站栏目导航入口，则检查所有二级页面上的链接。</div>
               <div class="txt-box">2.其他页面上的链接（包括图片、附件、外部链接等）打不开或错误的，每发现一处，扣0.1分</div>
            </th>
          </tr>
          <tr>
            <th class="th-three" rowspan="4">栏目更新情况</th>
            <th class="th-two">动态要闻类栏目</th>
            <th>
              <div class="txt-box">1. 未开设动态要闻类栏目的，扣3分。</div>
              <div class="txt-box">2. 监测时间点前2周内未更新的，扣3分。</div>
            </th>
          </tr>
          <tr>
            <th class="th-two">政策文件类栏目</th>
            <th>
              <div class="txt-box">1. 未开设政策文件类栏目的，扣3分。</div>
              <div class="txt-box">2. 监测时间点前6个月内政策文件类一级栏目未更新的，扣3分。</div>
            </th>
          </tr>
          <tr>
            <th class="th-two">政策解读类栏目</th>
            <th>
              <div class="txt-box">1. 未开设政策解读类栏目的，扣3分。</div>
              <div class="txt-box">2. 监测时间点前6个月内政策解读类一级栏目未更新的，扣3分。</div>
            </th>
          </tr>
          <tr>
            <th class="th-two">其他类栏目</th>
            <th>
              <div class="txt-box">1. 其他栏目存在空白的，每发现一个，扣1分。</div>
              <div class="txt-box">2. 其他栏目存在应更新未更新的，每发现一个，扣0.5分。</div>
              <div class="txt-box">3. 因空白、应更新未更新等原因已按其他指标扣分的，本指标项下不重复扣分。</div>
            </th>
          </tr>
          <tr>
            <th  colspan="4">
              <div class="end-box">
                   说明：<div>
                      <div>1. 综合扣分项评分结果低于60分，则判定检测结果为不合格。</div>  
                      <div> 2. 综合扣分项评分结果高于60分，且单项否决项合格，则判定检测结果为合格。</div>  
                      <div> 3. 单项否决项的结果将会直接影响到最终的检测结果。</div>     
                      <div> 4. 本表评分标准依照政府网站考核指标设定，本表仅列出已使用系统自动监测的部分，所得结果非实际考核结果，请知悉。</div>                  
                    </div>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      </div>
      <div @click="handleClose" class="btn">我知道了</div>
    </div>
  </el-dialog>
</template>
<script >
export default {
  data() {
    return {};
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
.th {
  width: 100px;
  text-align: center;
   padding-left: 16px;
    padding-right: 16px;
}
.dis-box {
  display: flex;
}
th{
   border:solid 1px #E4E7ED;
   background-color: rgba(255, 255, 255, 1);
    color:rgba(102, 111, 128, 1);
    font-size: 13px;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    font-weight: normal !important;
}
.title-th{
  height: 36px;
  line-height: 20px;
  background-color: rgba(245, 247, 250, 1);
  font-size: 13px;
  text-align: center;
  color: #000 !important;
  font-weight: 600;
}
.th-two{
  width: 120px;
  text-align: center;
}
.th-three{
  width: 46px;
  text-align: center;
}
.txt-box{
  margin-bottom: 5px;
}
.end-box{
  display: flex;
  width: 100%;
}
/deep/ .el-dialog__body{
   padding: 0px 20px;
   padding-top: 10px;
}
.btn{
  width: 96px;
  height: 36px;
  line-height: 20px;
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  text-align: center;
  border: 1px solid rgba(23, 109, 230, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  text-align: center;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 24px;
  margin-left: auto;
  cursor: pointer;
}
/deep/ .el-dialog{
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}

</style>
